import React from "react";
import SourceApp from "../src/containers/SourceApp";
// import FullStory from "react-fullstory";
import {store} from "./store"
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { hotjar } from 'react-hotjar';
import FullStory from "react-fullstory";
import tracker from "./analytics/tracker";

hotjar.initialize(2719557, 6);



Sentry.init({
  dsn: "https://a3bfb751a49c4dd3a36a2ed798131472@o1032636.ingest.sentry.io/5999596",
  integrations: [new Integrations.BrowserTracing()],
  autoSessionTracking: true,
  environment:process.env.REACT_APP_ENV,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});


const App = () => (
  <>
   <Provider store={store}>
    {process.env.REACT_APP_ENV === "prod" ? (
      <FullStory org={process.env.REACT_APP_FULL_STORY} />
    ) : null}
    <SourceApp />
     </Provider>
  </>
);

export default tracker(App);
